import { AddressBasedTemplateDetailPage } from "../check-arguments-templates-shared";
import { INTERNATIONAL_CRIMINAL_DATABASE_TEMPLATE_PAGE_CONFIG } from "./config";

export function InternationalCriminalDatabaseTemplateDetailPage() {
  return (
    <AddressBasedTemplateDetailPage
      config={INTERNATIONAL_CRIMINAL_DATABASE_TEMPLATE_PAGE_CONFIG}
    />
  );
}
